import * as firebase from 'firebase/app';
import { getMessaging, getToken, onMessage } from 'firebase/messaging';
import { firebaseConfig } from '@/config/firebase.config';
import { useUserNotificationsStore } from '~/stores/user-notification';

export const isFirebaseSupported = () =>
  'Notification' in window &&
  'serviceWorker' in navigator &&
  'PushManager' in window &&
  Notification?.permission === 'granted';

// Firebase needs to be initialized in the Webapp AND in the Service Worker (firebase-messaging-sw.js)
// Please don't remove one of them
export const firebaseApp = firebase.initializeApp(firebaseConfig);

export const firebaseMessaging = isFirebaseSupported()
  ? getMessaging(firebaseApp)
  : undefined;

function waitForSW() {
  return new Promise(async (resolve) => {
    if ('serviceWorker' in navigator) {
      await navigator.serviceWorker.ready;
      resolve(true);
    } else {
      resolve(false);
    }
  });
}

export const initFirebaseMessagingAndGetFCMToken = async () => {
  if (!firebaseApp || !firebaseMessaging || !isFirebaseSupported()) {
    return false;
  }

  try {
    const userNotificationsStore = useUserNotificationsStore();
    const { $pwa } = useNuxtApp();

    if ((await waitForSW()) === false) {
      throw new Error('Service Worker was unable to be registered');
    }

    let swRegistration = await navigator.serviceWorker.getRegistration();

    if (!swRegistration) {
      swRegistration = $pwa!.getSWRegistration();
    } else {
      swRegistration.update();
    }

    const token = await getToken(firebaseMessaging, {
      vapidKey:
        'BIBXGTZXZEDE3ZL6r1gpcuGrP1Z_oygdlc_xFqSXSm62DEpfqfVN2fGWy55fhrG7yk9HlUL2wn1c3Kud2OanWMU',
      serviceWorkerRegistration: swRegistration,
    });

    // User Notifications

    // onMessage(firebaseMessaging) can only be defined and listened to once for the whole application
    // If this is defined multiple times with the same "FirebaseMessaging" as parameter in our app,
    // every listener besides one of them will be ignored
    const defaultMessageSize = 10;
    userNotificationsStore.fetch({ size: defaultMessageSize });
    onMessage(firebaseMessaging, () => {
      userNotificationsStore.fetch({ size: defaultMessageSize });
    });

    return token;
  } catch (error) {
    if (Notification?.permission === 'granted') {
      useErrorHandler(error, false);
    }
  }
};
